<script lang="ts">
  import { storyblokEditable } from "@storyblok/svelte";
  import StoryblokComponent from "$lib/StoryblokComponent.svelte";
  import type { PageStoryblok } from "$types/components";
  import {
    page,
    pageMainColor,
    pageMainColorUsage,
    headerVariant,
    heroBackgroundColor,
    transitionState,
  } from "$stores";
  import Footer from "$lib/views/Footer.svelte";
  import { getAppContext } from "./utils/contexts";
  import type { ThemeBackgroundColor } from "./utils/helpers";

  export let blok: PageStoryblok;

  page.set(blok);

  transitionState.subscribe((state) => {
    if (!state || state === "out" || state === "initial") {
      pageMainColor.set(blok?.page_main_color ?? "");
    }
  });

  pageMainColorUsage.set(blok?.page_main_color_usage ?? "hero-footer");
  heroBackgroundColor.set(
    (blok?.hero_background_color ?? "") as ThemeBackgroundColor,
  );
  headerVariant.set(blok?.header_variant ?? "default");

  const background =
    blok?.page_main_color_usage === "hero-footer"
      ? blok.hero_background_color
      : "none";

  const footerNavigation = getAppContext("footerNavigation");
  const socials = getAppContext("socials");
  const footerBottomLinks = getAppContext("footerBottomLinks");
</script>

{#key blok}
  <div use:storyblokEditable={blok} class="page">
    {#if (blok?.hero?.length ?? 0) > 0}
      <StoryblokComponent
        blok={blok.hero?.[0]}
        theme={blok.page_main_color}
        {background}
      />
    {/if}

    {#if blok.body}
      <div class="content">
        {#each blok.body as pageBlok}
          <StoryblokComponent blok={pageBlok} />
        {/each}
      </div>
    {/if}
  </div>

  <Footer
    theme={blok.page_main_color}
    categories={blok.footer_categories}
    {socials}
    {footerBottomLinks}
    navigation={footerNavigation}
    backgroundColor={blok.footerBackgroundColor}
    margin={blok.footerGap}
  />
{/key}

<style lang="scss">
  .content {
    background: rgb(var(--color-light-grey));
    position: relative;
    z-index: 5;
  }
</style>
